import React, { Component } from 'react';
import ReportMeasure from 'customers/reports/ReportMeasure';
import autobind from 'autobind-decorator';
import { ListGroup, ListGroupItem } from 'reactstrap';

export class ReportSearch extends Component {

    constructor(props) {
        super(props)
        const { report } = props
        const { catalog_checkpoints: reportMeasureList } = report
        this.state = {
            isVisible: false,
            reportMeasureList: reportMeasureList,
        };
    }

    @autobind
    toggleVisibility(event) {
        event.preventDefault();
        this.setState({
            isVisible: !this.state.isVisible
        });
    }

    @autobind
    updateMeasure(reportMeasure) {
        const { reportMeasureList } = this.state
        this.setState({
            reportMeasureList: reportMeasureList.map(
                el => el.id === reportMeasure ? reportMeasure : el
            )
        })
    }

    @autobind
    addReportMeasure(reportMeasure) {
        const { reportMeasureList } = this.state
        this.setState(
            { reportMeasureList: [...reportMeasureList, reportMeasure] }
        )
    }

    @autobind
    removeReportMeasure(reportMeasure) {
        const { reportMeasureList } = this.state
        this.setState({
            reportMeasureList: reportMeasureList.filter(
                el => el.id !== reportMeasure.id
            )
        })
    }

    @autobind
    isActive(measure) {
        const index = this.state.reportMeasureList.findIndex(
            el => el.measure === measure.id
        )
        return index > -1
    }

    render() {
        const report = this.props.report
        const measureList = this.props.measureList;

        return (
            <ListGroup>
                {
                    measureList.map((measure, index) => (
                            <ReportMeasure
                                measure={measure}
                                report={report}
                                add={this.addReportMeasure}
                                update={this.updateMeasure}
                                remove={this.removeReportMeasure}
                                reportMeasureList={this.state.reportMeasureList}
                                index={index}
                                key={`report_measure_${index}`}
                            />
                        )
                    )
                }
            </ListGroup>
        )
    }
}
